import React, {useState} from "react";
import {ReactComponent as SearchInvidual} from "../../../assets/elevva-pro-icons/search-individual-table.svg";
import {ReactComponent as Person} from "../../../assets/elevva-pro-icons/person-service-modificate.svg";
import {ReactComponent as Clock} from "../../../assets/elevva-pro-icons/clock-service-modificate.svg";
import {ReactComponent as Location} from "../../../assets/elevva-pro-icons/location-service-modificate.svg";
import {ReactComponent as ListAwaitIcon} from "../../../assets/elevva-pro-icons/list_await_icon.svg";

import moment from "moment";
import InlineModal from "../../info-modal/infoModal";
import {instanceMob} from "../../../utils/utils";
import Tooltip from "../../tooltip/tooltip";

const CardBookingsList = (props) => {
    const {modalServiceDetail, modalWaitListDetail, booking: service, schedule} = props;

    const now = moment();
    const startTime = moment(schedule.start_time, "HH:mm:ss");
    const endTime = moment(schedule.end_time, "HH:mm:ss");
    const isNowBetween = now.isBetween(startTime, endTime);
    const dayNow = now.format("YYYY-MM-DD");
    const isDayNow = dayNow === schedule.day;

    const [modalData, setModalData] = useState({
        show: false,
        title: "",
        description: "",
        primaryAction: null,
        secondaryAction: null,
    });

    const openModal = ({title, description, primaryAction, secondaryAction}) => {
        setModalData({show: true, title, description, primaryAction, secondaryAction});
    };

    const closeModal = () => {
        setModalData((prev) => ({...prev, show: false}));
    };

    function toggleBlockTime({item, action, refreshList}) {
        const url =
            action === "block"
                ? "admin/availability/block-times"
                : "admin/availability/block-times/delete";

        const dateTime = `${item.day} ${item.start_time.substring(0, 5)}`;

        const payload = {
            availability_id: item.id,
            blocked_times: [dateTime],
        };

        const request =
            action === "block"
                ? instanceMob.post(url, payload)
                : instanceMob.delete(url, {data: payload});

        return request
            .then(() => {
                closeModal();
                refreshList();
            })
            .catch((err) => {
                closeModal();

                const errorData = err?.response?.data;
                const errorMessage = Array.isArray(errorData)
                    ? errorData[0]
                    : typeof errorData === "string"
                        ? errorData
                        : errorData?.error || "Ocurrió un error inesperado.";

                if (errorMessage.startsWith("No se puede bloquear la hora")) {
                    openModal({
                        title: "No es posible bloquear esta clase",
                        description: "Actualmente hay usuarios con reservas activas en esta clase. Para continuar, primero debes eliminar todas las reservas asociadas. Una vez hecho esto, podrás bloquear la clase sin inconvenientes.",
                        primaryAction: {
                            label: "Eliminar usuarios",
                            onClick: () => {
                                closeModal(); // Cierra el inline modal
                                modalServiceDetail(
                                    item.id,
                                    `${item.day} ${moment(item.start_time, "HH:mm").format("HH:mm")}`,
                                    false,
                                    item?.available_slots || 0
                                );
                            }
                        },
                        secondaryAction: {
                            label: "Cancelar",
                            onClick: closeModal
                        }
                    });
                } else {
                    openModal({
                        title: "Error",
                        description: errorMessage,
                        primaryAction: {
                            label: "Aceptar",
                            onClick: closeModal,
                        },
                    });
                }
            });
    }

    const getTextColor = ({isNowBetween, isDayNow, blocked, wait_bookings}) => {
        if (wait_bookings > 0) return "red";
        if (isDayNow && isNowBetween) return "#FFFFFF";
        if (isDayNow && blocked) return "#9DACBD";
        return "#394F65";
    };

    const getIconColor = ({isNowBetween, isDayNow, blocked, wait_bookings}) => {
        if (wait_bookings > 0) return "red";
        if (isDayNow && isNowBetween) return "#FFFFFF";
        if (isDayNow && blocked) return "#9DACBD";
        return "#3177BE";
    };


    return (
        <>
            <div
                className={`d-flex flex-column w-100 align-items-center gap-0  px-3 mx-auto`}
                style={{
                    maxWidth: "calc(100vw - 25%)",
                    background:
                        isNowBetween && isDayNow
                            ? service.blocked
                                ? "#9DACBD"
                                : "#3177BE"
                            : "#ffffff",
                    borderRadius: isNowBetween && isDayNow ? "30px" : "0px",
                }}
            >
                <div className={`d-flex w-100 align-items-center gap-0  px-3 mx-auto`}
                     style={{
                         borderBottom: "1px solid #A8C2D7"
                     }}
                >
                    <div className="flex-grow-1 ">
                        <div className="d-flex align-items-center justify-content-between gap-2 small">
                            <div
                                className="me-3 cursor-pointer"
                                onClick={() =>
                                    openModal({
                                        title: service.blocked
                                            ? "¿Deseas reactivar esta clase?"
                                            : "¿Deseas bloquear esta clase?",
                                        description: service.blocked
                                            ? "Esta clase ha sido previamente bloqueada. Al reactivarla, los usuarios podrán nuevamente reservar un cupo en ella desde su app. Puedes hacerlo ahora si deseas que vuelva a estar disponible en el horario asignado."
                                            : "Esta acción impedirá que los usuarios puedan reservar esta clase en la fecha y hora seleccionada. Puedes revertir esta acción más adelante desde el mismo panel si lo consideras necesario.",
                                        primaryAction: {
                                            label: "Confirmar",
                                            onClick: () =>
                                                toggleBlockTime({
                                                    item: service,
                                                    action: service.blocked ? "unblock" : "block",
                                                    refreshList: props.getListBookings,
                                                }),
                                        },
                                        secondaryAction: {
                                            label: "Cancelar",
                                            onClick: closeModal,
                                        },
                                    })
                                }
                            >
                                {service.blocked ? (
                                    isNowBetween && isDayNow ? (
                                        <Tooltip title="Reactivar Clase">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                                                <path d="M14 11L10 15L14 19" stroke="white" strokeWidth="2"/>
                                                <path
                                                    d="M4.20577 12.75C3.21517 11.8921 2.8184 10.8948 3.077 9.91263C3.3356 8.9305 4.23511 8.01848 5.63604 7.31802C7.03696 6.61756 8.86101 6.1678 10.8253 6.0385C12.7895 5.9092 14.7842 6.10758 16.5 6.60289C18.2158 7.09819 19.5567 7.86273 20.3149 8.77792C21.0731 9.69312 21.2061 10.7078 20.6933 11.6647C20.1806 12.6215 19.0507 13.467 17.4789 14.0701C15.9071 14.6731 13.9812 15 12 15"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip title="Reactivar Clase">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                                                <path d="M14 11L10 15L14 19" stroke="#3177BE" strokeWidth="2"/>
                                                <path
                                                    d="M4.20577 12.75C3.21517 11.8921 2.8184 10.8948 3.077 9.91263C3.3356 8.9305 4.23511 8.01848 5.63604 7.31802C7.03696 6.61756 8.86101 6.1678 10.8253 6.0385C12.7895 5.9092 14.7842 6.10758 16.5 6.60289C18.2158 7.09819 19.5567 7.86273 20.3149 8.77792C21.0731 9.69312 21.2061 10.7078 20.6933 11.6647C20.1806 12.6215 19.0507 13.467 17.4789 14.0701C15.9071 14.6731 13.9812 15 12 15"
                                                    stroke="#3177BE"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                        </Tooltip>
                                    )
                                ) : isNowBetween && isDayNow ? (
                                    <Tooltip title="Bloquear Clase">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                                            <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="2"/>
                                            <path d="M18 18L6 6" stroke="white" strokeWidth="2"/>
                                        </svg>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Bloquear Clase">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                                            <circle cx="12" cy="12" r="9" stroke="#394F65" strokeWidth="2"/>
                                            <path d="M18 18L6 6" stroke="#394F65" strokeWidth="2"/>
                                        </svg>
                                    </Tooltip>
                                )}
                            </div>
                            <div className="col-3">
                                <span
                                    style={{
                                        color: getTextColor({
                                            isNowBetween,
                                            isDayNow,
                                            blocked: service.blocked,
                                            wait_bookings: 0,
                                        }),
                                        fontSize: "calc(.4rem + .4vw)",
                                    }}
                                >
                                    {service.service_name}
                                </span>
                            </div>
                            <div className="col-3">
                                <Tooltip title="Fecha y hora de la clase">
                                    <Clock
                                        className="me-2"
                                        size={16}
                                        style={{
                                            color: getIconColor({
                                                isNowBetween,
                                                isDayNow,
                                                blocked: service.blocked,
                                                wait_bookings: 0,
                                            }),
                                        }}
                                    />
                                </Tooltip>
                                <span
                                    style={{
                                        color: getTextColor({
                                            isNowBetween,
                                            isDayNow,
                                            blocked: service.blocked,
                                            wait_bookings: 0,
                                        }),
                                        fontSize: "calc(.4rem + .4vw)",
                                    }}
                                >
                                    {moment(schedule.day).format("DD-MMM-YY")} /{" "}
                                    {startTime.format("h:mm a ")} - {endTime.format("h:mm a ")}
                                </span>
                            </div>

                            <div className="col-3 d-flex align-items-center">
                                <span
                                    className="me-2"
                                >
                                    <Tooltip title="Duración de la clase">
                                        <Clock
                                            style={{
                                                color: getIconColor({
                                                    isNowBetween,
                                                    isDayNow,
                                                    blocked: service.blocked,
                                                    wait_bookings: 0,
                                                })
                                            }}
                                        />
                                    </Tooltip>
                                </span>
                                <span
                                    style={{
                                        color: getTextColor({
                                            isNowBetween,
                                            isDayNow,
                                            blocked: service.blocked,
                                            wait_bookings: 0,
                                        }),
                                        fontSize: "calc(.4rem + .4vw)",
                                    }}
                                    className="me-3"
                                >
                                    {service.duration} min
                                </span>
                                <Person
                                    size={16}
                                    className="me-2"
                                    style={{
                                        color: getIconColor({
                                            isNowBetween,
                                            isDayNow,
                                            blocked: service.blocked,
                                            wait_bookings: 0,
                                        })
                                    }}
                                />
                                <span
                                    style={{
                                        color: getTextColor({
                                            isNowBetween,
                                            isDayNow,
                                            blocked: service.blocked,
                                            wait_bookings: 0,
                                        }),
                                        fontSize: "calc(.4rem + .4vw)",
                                    }}
                                >
                                    {" "}
                                    {schedule?.attendees_count || 0}/{schedule.available_slots}{" "} cupos
                                </span>{" "}
                            </div>
                            <div
                                className="col-1 cursor-pointer"
                                onClick={() =>
                                    modalWaitListDetail(
                                        service.id,
                                        `${schedule.day} ${moment(
                                            schedule.start_time,
                                            "HH:mm"
                                        ).format("HH:mm")}`,
                                        service.service_name,

                                        schedule?.available_slots || 0,
                                        schedule?.wait_bookings_total || 0
                                    )
                                }
                            >
                                <Tooltip title="Lista de asistentes">
                                    <ListAwaitIcon
                                        size={16}
                                        style={{
                                            color: getIconColor({
                                                isNowBetween,
                                                isDayNow,
                                                blocked: service.blocked,
                                                wait_bookings: service.wait_bookings,
                                            })
                                        }}
                                    />

                                </Tooltip>
                                <span
                                    style={{
                                        color: getTextColor({
                                            isNowBetween,
                                            isDayNow,
                                            blocked: service.blocked,
                                            wait_bookings: service.wait_bookings,
                                        }),
                                        fontSize: "calc(.4rem + .4vw)",
                                    }}
                                >
                                    {" "}
                                    {service.wait_bookings}
                                </span>
                            </div>
                            <div className="col-2">
                                <Location
                                    size={16}
                                    style={{
                                        color: getIconColor({
                                            isNowBetween,
                                            isDayNow,
                                            blocked: service.blocked,
                                            wait_bookings: 0,
                                        })
                                    }}
                                />
                                <span
                                    style={{
                                        color: getTextColor({
                                            isNowBetween,
                                            isDayNow,
                                            blocked: service.blocked,
                                            wait_bookings: 0,
                                        }),
                                        fontSize: "calc(.4rem + .4vw)",
                                    }}
                                >
                                    {" "}
                                    {service.location_name}
                                </span>
                            </div>
                        </div>
                    </div>

                    <button className="btn btn-link rounded-circle p-2">
                        <Tooltip title="Modificar asistencia">
                            <svg
                                className="cursor-pointer"
                                style={{backgroundColor: '#B5C1CD', borderRadius: '50%'}}
                                xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                fill="none"
                                onClick={() =>
                                    modalServiceDetail(
                                        service.id,
                                        `${schedule.day} ${moment(
                                            schedule.start_time,
                                            "HH:mm"
                                        ).format("HH:mm")}`,
                                        false,
                                        schedule?.available_slots || 0
                                    )
                                }
                            >
                                <path
                                    d="M9.69478 15.3693C9.79948 13.5305 10.6443 11.8066 12.4544 11.8066C14.2646 11.8066 15.1094 13.5305 15.2141 15.3693C15.2265 15.5876 15.048 15.765 14.8294 15.765H10.0794C9.86081 15.765 9.68236 15.5876 9.69478 15.3693Z"
                                    fill="#2A4157" fill-opacity="0.24"/>
                                <circle cx="12.4557" cy="9.03581" r="1.97917" fill="#2A4157" fill-opacity="0.24"/>
                                <path
                                    d="M4.94467 15.368C5.07051 13.132 6.27513 11.0137 8.89193 11.0137C11.5087 11.0137 12.7133 13.132 12.8392 15.368C12.8515 15.5863 12.673 15.7637 12.4544 15.7637H5.32943C5.11081 15.7637 4.93239 15.5863 4.94467 15.368Z"
                                    fill="white"/>
                                <circle cx="8.89453" cy="7.84766" r="2.375" fill="white"/>
                                <path d="M15.6224 4.28516V7.45182M17.2057 5.86849L14.0391 5.86849" stroke="white"
                                      stroke-width="0.791667" stroke-linecap="round"/>
                            </svg>
                        </Tooltip>
                    </button>


                </div>

            </div>

            {modalData.show && (
                <InlineModal
                    title={modalData.title}
                    description={modalData.description}
                    primaryAction={{
                        label: modalData.primaryAction?.label,
                        onClick: modalData.primaryAction?.onClick,
                    }}
                    secondaryAction={{
                        label: modalData.secondaryAction?.label,
                        onClick: modalData.secondaryAction?.onClick,
                    }}
                />
            )}
        </>

    );
};

export default CardBookingsList;
